<section class="sites-shell">
  <header class="page-header">
    <div>
      <p class="eyebrow">Administration</p>
      <h1>Sites</h1>
      @if (activeSiteName) {
        <p class="context-site">
          Active site:
          <strong>{{ activeSiteName }}</strong>
        </p>
      }
      <p class="intro">Review each site’s content footprint, then open a single site workspace to rename it or manage its API keys.</p>
    </div>
    @if (!showCreateSiteForm) {
      <button type="button" class="accent" (click)="openCreateSiteForm()">Add site</button>
    }
  </header>

  <section class="summary-strip" aria-label="Site summary">
    <div class="summary-cell">
      <span>Total sites</span>
      <strong>{{ sites.length }}</strong>
    </div>
    <div class="summary-cell">
      <span>Total landing pages</span>
      <strong>{{ totalLandingPages }}</strong>
    </div>
    <div class="summary-cell">
      <span>Total API keys</span>
      <strong>{{ totalApiKeys }}</strong>
    </div>
    <div class="summary-cell">
      <span>Total links</span>
      <strong>{{ totalLinks }}</strong>
    </div>
  </section>

  @if (showCreateSiteForm) {
    <section class="site-form-panel">
      <div class="site-form-header">
        <div>
          <p class="eyebrow">New record</p>
          <h2>Add site</h2>
        </div>
        <button type="button" class="ghost small" (click)="closeCreateSiteForm()">Cancel</button>
      </div>

      <div class="site-form">
        <label>
          <span>New site name</span>
          <input [(ngModel)]="draftName" placeholder="engineering-docs" />
        </label>
        <button type="button" class="accent" (click)="createSite()">Create site</button>
      </div>
    </section>
  }

  @if (error) {
    <p class="error">{{ error }}</p>
  }

  <section class="table-panel">
    <header class="table-panel-header">
      <div>
        <p class="eyebrow">Records</p>
        <h2>Registered sites</h2>
      </div>
    </header>

    @if (sites.length) {
      <div class="table-wrap">
        <table>
          <thead>
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Landing pages</th>
              <th scope="col">Links</th>
              <th scope="col">Public keys</th>
              <th scope="col">Created</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            @for (site of sites; track site.id) {
              <tr>
                <td class="name-cell">
                  {{ site.name }}
                  @if (site.id === activeSiteId) {
                    <span class="site-state">Active</span>
                  }
                </td>
                <td>{{ site.landingPageCount }}</td>
                <td>{{ site.linkCount }}</td>
                <td>{{ site.publicApiKeyCount }}</td>
                <td>{{ site.createdAt | date: 'mediumDate' }}</td>
                <td>
                  <div class="site-actions">
                    <a class="ghost small" [routerLink]="['/sites', site.id]">Manage site</a>
                    <button type="button" class="ghost small" (click)="openDashboard(site.id)">Open dashboard</button>
                    <button type="button" class="ghost small" (click)="openLandingPages(site.id)">View landing pages</button>
                    <button type="button" class="ghost small" (click)="openLinks(site.id)">View links</button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    } @else {
      <p class="empty-state">No sites yet. Click Add site to create the first site.</p>
    }
  </section>
</section>
